import { render, staticRenderFns } from "./StatusFilters.template.vue?vue&type=template&id=018877f1&scoped=true&"
var script = {}
import style0 from "./StatusFilters.template.vue?vue&type=style&index=0&id=018877f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018877f1",
  null
  
)

export default component.exports